<div id="content" class="allcp-form" ng-controller="ProfitAnalyticController" ng-init="init()">
    <div ng-include="'modules/company/menus/report_menu.html'"></div>
    <div class="row mt20">
        <div class="col-md-12 mb20">
            <div class="panel date-range">
                <div class="panel-body" >
                    
                    <div class="row mt50">
                        <div class="col-lg-3">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-file-text-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Toplam Kargo</p>
                                    <div class="row">
                                        <h3><i class="fa fa-pie-chart"></i> {{ data.count.total?data.count.total:0 }} </h3>
                                        <hr style="margin: 10px;border-top: 1px solid #54aed3;">
                                        <h5><i class="fa fa-money"></i> {{ data.total_credit?data.total_credit:0 }} ₺</h5>
                                    </div>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-check-square-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Tamamlanan Kargo</p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ data.count.success?data.count.success:0 }} </h3>
                                    <hr style="margin: 10px;border-top: 1px solid #74bc66;">
                                    <h3><i class="fa fa-money"></i> {{ data.success_credit?data.success_credit:0 }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="small-box bg-yellow">
                                <div class="icon small-box-icon-yellow">
                                    <i class="fa fa-sun-o"></i>
                                </div>
                                <div class="inner">
                                    <p>Devam Eden Kargo</p>
                                    <h3><i class="fa fa-pie-chart"></i> {{ data.count.total - (data.count.success + data.count.fail) }} </h3>
                                    <hr style="margin: 10px;border-top: 1px solid #d7b40d;">
                                    <h3><i class="fa fa-money"></i> {{ data.total_credit - (data.success_credit + data.fail_credit) }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="small-box bg-red">
                                <div class="icon small-box-icon-red">
                                    <i class="fa fa-times"></i>
                                </div>
                                <div class="inner">
                                    <p>İade Olan Kargo / Tutar</p>
                                    <h3><i class="fa fa-pie-chart"></i> 
                                        {{ data.count.fail?data.count.fail:0 }}
                                    </h3>
                                    <hr style="margin: 10px;border-top: 1px solid #bc3f2a;">
                                    <h3><i class="fa fa-money"></i> {{ data.fail_credit?data.fail_credit:0 }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row mt50">
                        <div class="col-lg-3">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Toplam Taşınan Tutar</p>
                                    <h3><i class="fa fa-signal"></i> {{ data.total_credit | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3" ng-repeat="item in data.money_by_type" ng-if="$index == 0">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>{{ item.name }} Kapıda Alınan Tutar</p>
                                    <h3><i class="fa fa-signal"></i> {{ item.sum | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3" ng-repeat="item in data.money_by_type" ng-if="$index == 1">
                            <div class="small-box bg-yellow">
                                <div class="icon small-box-icon-yellow">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>{{ item.name }} Kapıda Alınan Tutar</p>
                                    <h3><i class="fa fa-signal"></i> {{ item.sum | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-3" ng-repeat="item in data.money_by_type" ng-if="$index == 2">
                            <div class="small-box bg-red">
                                <div class="icon small-box-icon-red">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>{{ item.name }} Kapıda Alınan Tutar</p>
                                    <h3><i class="fa fa-signal"></i> {{ item.sum | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="row mt50">
                        <div class="col-lg-2">
                            <div class="small-box bg-blue">
                                <div class="icon small-box-icon-blue">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Toplam Müşteri Borç Tutarı</p>
                                    <h3><i class="fa fa-signal"></i> {{ totalMoney | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>

                    </div> -->

                    <div class="row mt50">

                        <div class="col-lg-2">
                            <div class="small-box bg-orange">
                                <div class="icon small-box-icon-orange">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Teslim Edilmiş Toplam Kargo Tutar</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.success_total | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                        <!-- <div class="col-lg-2">
                            <div class="small-box bg-orange">
                                <div class="icon small-box-icon-orange">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Teslim Edilmiş Karşıdan Ödemeli Tutar</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.payable_total | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div> -->
                        <div class="col-lg-2">
                            <div class="small-box bg-red">
                                <div class="icon small-box-icon-red">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Müşteriye Verilen Toplam Tutar</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.payment_by_customer.verilen | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>

                        <div class="col-lg-2">
                            <div class="small-box bg-green">
                                <div class="icon small-box-icon-green">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Müşteriden Alınan Toplam Tutar</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.payment_by_customer.alinan | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>


                        <!-- <div class="col-lg-2">
                            <div class="small-box bg-red">
                                <div class="icon small-box-icon-red">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Müşteri Kredi Tutarı</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.company_credit | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div> -->
                        <div class="col-lg-2">
                            <div class="small-box bg-orange">
                                <div class="icon small-box-icon-orange">
                                    <i class="fa fa-money"></i>
                                </div>
                                <div class="inner">
                                    <p>Müşteri Toplam Borç Tutar</p>
                                    <h3><i class="fa fa-line-chart"></i> {{ data.customer_total_money | number : 2  }} ₺</h3>
                                </div>
                                <a href="#" class="small-box-footer"> Hodxpress
                                    <i class="fa fa-arrow-circle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-md-7">
                            <div class="table-responsive" ng-if="data.orders.data.length > 0">
                                <table class="table table-hover tc-checkbox-1 fs13">
                                    <thead>
                                        <tr class="bg-light">
                                            <th>
                                                NO
                                                <a ng-click="sort('id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('id','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>Açıklama</th>
                                            <th>Teslimat M.</th>
                                            <th>Ödeme Türü</th>
                                            <th>Ödeme Miktarı</th>
                                            <th>
                                                Personel
                                                <a ng-click="sort('worker_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('worker_id','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>Teslim Süresi</th>
                                            
                                            <th>
                                                Tarihi
                                                <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                           <th>
                                                Türü
                                                <a ng-click="sort('work_type','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('work_type','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>
                                                Durumu
                                                <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th ng-repeat="item in data.fields">{{ item.name }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr 
                                        dir-paginate="item in data.orders.data | itemsPerPage: 30" 
                                        total-items="data.orders.total" 
                                        current-page="data.orders.current_page"
                                        ng-class="{ 'success' : item.status.id == data.successID  }">
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">#{{item.id}}</td>
                                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.name | cut:true:40:' ...' }}</td>
                                        
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            {{ item.location.name }} - {{ item.location.phone_number }}
                                        </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            <span ng-if="item.order_payment == 'online'">Kapıda Ödeme</span>
                                            <span ng-if="item.order_payment == 'offline'">Ödendi</span>
                                            <span ng-if="item.order_payment == 'payable'">Karşıdan Ödemeli</span>
                                        </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            {{ item.order_payment == 'online' ? item.price + '₺' : '-' }}
                                        </td>
            
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.worker.user.full_name }} </td>
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ humanizeDuration(item.time, { units: ['d', 'h'] }) }}</td>
                                        <!--
                                            <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.distance }} KM</td>
                                        -->
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
                                        <!-- <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td> -->
                                        <!-- <td 
                                            ng-repeat="fields in data.steps | orderBy:'sort'"
                                            class="clickable-row" 
                                            ng-click="getOrderDetails(item)">
                                            <span ng-repeat="field in item.logs | filter:{ proccess: fields.id }" ng-if="$index == 0">
                                                {{ field.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}
                                            </span>
                                        </td> -->
                                        
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.work_type.name }}</td>
                                        <!-- <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.note_count }}</td>								
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.image_count }}</td>								
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.form ? item.form.name : '-' }}</td> -->
                                        <!-- <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.rate ? item.rate : '-' }}</td> -->								
            
                                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                                            <span ng-if="item.status"ng-style="{'color': item.status.color }">{{ item.status.name }}</span>	
                                            <span ng-if="!item.status">Created</span>
                                        </td>
                                        <td 
                                            ng-repeat="fields in data.fields"
                                            class="clickable-row" 
                                            ng-click="getCustomerDetails(item.id)">
                                            <span ng-repeat="field in item.fields_values">
                                                {{ fields.id == field.customer_field_id ? field.value : '' }}
                                            </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <dir-pagination-controls 
                                    boundary-links="true" 
                                    on-page-change="getPage(newPageNumber)" 
                                    template-url="dirPagination.tpl.html"
                                    class="pagination-lg pagination">
                                </dir-pagination-controls>
                            </div>

                            <div class="table-responsive" ng-if="data.orders.data.length == 0">
                                <div class="alert alert-default pastel">
                                    <i class="fa fa-info pr10"></i>
                                    <strong>
                                        Aradığınız kritelerde iş bulunamadı!
                                    </strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="table-responsive" ng-if="data.payments.length > 0">
                                <table class="table table-hover tc-checkbox-1 table-scroll fs13" style="border:0px !important">
                                    <thead>
                                        <tr class="bg-light">
                                            <th class="text-center">
                                                <label class="option block mn ml4" style="display:block">
                                                    <input type="checkbox" 
                                                        name="deleted[]" ng-model="master" ng-click="toggleSelection($event)"  id="checkboxAll" >
                                                    <span class="checkbox mn"></span>
                                                </label>
                                            </th>
                                            <th>
                                                ID
                                                <a ng-click="sort('id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('id','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>Açıklama</th>
                                            <th>Tutar</th>
                                            <th>Ödeme Türü</th>
                                            <th>
                                                Tarihi
                                                <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                                    <i class="fa fa-sort-alpha-desc"></i>
                                                </a>
                                                <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
                                                    <i class="fa fa-sort-alpha-asc"></i>
                                                </a>
                                            </th>
                                            <th>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr ng-repeat="item in data.payments">
                                        <td class="clickable-row">
                                            <label class="option block mn">
                                                <input type="checkbox" ng-click="addSelectedItem(item.id)" ng-checked="selectedItem.indexOf(item.id) > -1 || master" id="checkboxDefault-{{item.id}}">
                                                <span class="checkbox mn"></span>
                                            </label>
                                        </td>
                                        <td class="clickable-row">#{{item.id}}</td>
                                        <td class="clickable-row mw200">
                                            <div class="popover-wrapper">
                                                <a href="#" 
                                                    editable-text="item.description" 
                                                    onaftersave="updatePaymentData(item)">
                                                    {{ item.description }}
                                                </a>
                                            </div>
                                        </td>
                                        <td class="clickable-row mw200">
                                            <div class="popover-wrapper">
                                                <a href="#" 
                                                    editable-number="item.price" 
                                                    onaftersave="updatePaymentData(item)">
                                                    {{ item.price }}
                                                </a>
                                            </div>
                                        </td>
                                        <td class="clickable-row mw200">
                                            <span class="badge badge-success" ng-if="item.type == 0">Alınan Tutar</span>
                                            <span class="badge badge-warning" ng-if="item.type == 1">Verilen Tutar</span>
                                            <span class="badge badge-default" ng-if="item.type == 2">Kredi</span>
                                        </td>
                                        <td class="clickable-row">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
                                        <td>
                                            <a href="#" ng-click="deletePayment(item.id)" class="btn btn-danger">
                                                <i class="fa fa-trash"></i> Sil
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table-responsive" ng-if="data.payments.length == 0">
                                <div class="alert alert-default pastel">
                                    <i class="fa fa-info pr10"></i>
                                    <strong>
                                        Ödeme bulunamadı!
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
    <!-- payment Orders -->
    <div class="modal right fade" id="paymentOrdersModal" tabindex="-1" role="dialog" aria-labelledby="paymentOrdersModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="paymentOrdersModalLabel">Ödeme Ekle!</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <form action="">
                                <div class="form-group">
                                    <label for="">Tutar *</label>
                                    <input type="number" step="any" string-to-number class="form-control" placeholder="Tutar" ng-model="payment.price">
                                </div>
                                <div class="form-group">
                                    <label for="">Ödeme Türü *</label>
                                    <select name="" id="" class="form-control" ng-model="payment.type" required>
                                        <option value="">Seçim Yapınız</option>
                                        <option value="0">Alınan Tutar</option>
                                        <option value="1">Verilen Tutar</option>
                                        <option value="2">Kredi</option>
                                    </select>
                                </div>
                                <div class="form-group" ng-if="payment.type == 1">
                                    <label for="">EFT No</label>
                                    <input type="text" ng-model="payment.description" class="form-control" placeholder="EFT No" required>
                                </div>
                                <div class="form-group" ng-if="payment.type == 0">
                                    <label for="">Fatura No</label>
                                    <input type="text" ng-model="payment.description" class="form-control" placeholder="Fatura No" required>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer bg-light">
                    <button type="submit" class="btn pull-right btn-primary ml10" ng-click="addPayment()">Ödeme Ekle</button>
                    <button type="button" class="btn pull-right btn-default" data-dismiss="modal">İptal</button>
                </div>
            </div>
        </div>
    </div>

</div>